function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import includes from 'lodash/includes';
import Checkbox from '../checkbox/Checkbox';
/**
 * Given a set of checked values filter out the ones that are not in the full
 * list of values
 */

var _getValuesCheckedStatus = function _getValuesCheckedStatus() {
  var checkedList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // First create a lookup of the values so the function's complexity isn't
  // O(n^2) operation, but O(2n)
  var checkedListLookup = checkedList.reduce(function (prevLookup, value) {
    return _objectSpread({}, prevLookup, _defineProperty({}, value, true));
  }, {}); // Then go through each value and set its checked status based on its
  // presence in checkedListLookup

  var allValuesCheckedStatus = _.chain(allValues) // first convert the array of valueInfo objects to an array where first
  // item is the value string and the second item is whether or not the
  // value string is in the lookup
  .map(function (_ref) {
    var value = _ref.value;
    return [value, value in checkedListLookup];
  }) // convert that list of [valueString, checked] pairs into an object lookup
  // where the key is the valueString and the value is the checked status
  .fromPairs() // get back a raw object
  .value();

  return allValuesCheckedStatus;
};
/*
 * Converts an object lookup of values checked statuses to an array of the values
 * that are checked
 */


var _getCheckedList = function _getCheckedList(valuesCheckedStatus) {
  return _.chain(valuesCheckedStatus) // convert the lookup object into an array of [value, isChecked] pairs
  .toPairs() // filter down to only the pairs that are checked
  .filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        isChecked = _ref3[1];

    return isChecked;
  }) // transform from [value, isChecked] pairs to value strings
  .map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        value = _ref5[0];

    return value;
  }) // get out the value string
  .value();
};

var CheckboxComponent = function CheckboxComponent(_ref6) {
  var index = _ref6.index,
      name = _ref6.name,
      value = _ref6.value,
      htmlValue = _ref6.htmlValue,
      display = _ref6.display,
      isDisabled = _ref6.isDisabled,
      numberOfColumns = _ref6.numberOfColumns,
      onChange = _ref6.onChange,
      onBlur = _ref6.onBlur,
      onFocus = _ref6.onFocus;
  var id = "checkbox-".concat(name, "-").concat(index);
  var wrapperClassName = numberOfColumns > 1 ? "eds-g-cell eds-g-cell-".concat(12 / numberOfColumns, "-12 eds-l-mar-bot-4") : 'eds-l-mar-vert-4';
  return React.createElement("div", {
    "data-spec": "checkbox-wrapper",
    className: wrapperClassName
  }, React.createElement(Checkbox, {
    id: id,
    name: name,
    value: value,
    htmlValue: htmlValue,
    isDisabled: isDisabled,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    "data-spec": "checkbox-group"
  }, display));
};

var CheckboxGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CheckboxGroup, _PureComponent);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroup).call(this, props));
    var values = props.values,
        value = props.value,
        defaultValue = props.defaultValue;
    var checkedList = value || defaultValue;
    _this.state = {
      // Maintaining the currently checked values as an object lookup where
      // the key is the checkbox value and the value is whether it's checked.
      // This makes it easier to update checked status of checkboxes as
      // they change over time
      valuesCheckedStatus: _getValuesCheckedStatus(checkedList, values)
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref7) {
      var value = _ref7.value,
          values = _ref7.values;

      // We explicitly test for undefined for the case when the value is
      // specifically not passed
      if (value !== undefined) {
        // The first time any checkbox in the group is checked, redux-form passes
        // an empty string instead of an empty list. However, _getValuesCheckedStatus
        // always expects a list as the first param.
        var valueList = value === '' ? [] : value;
        this.setState({
          valuesCheckedStatus: _getValuesCheckedStatus(valueList, values)
        });
      }
    }
  }, {
    key: "_handleCheckboxChange",
    value: function _handleCheckboxChange(checkboxIsChecked, checkboxValue) {
      var _this2 = this;

      // update the checkbox's checked state in the overall values checked
      // state
      this.setState(function (_ref8) {
        var prevValuesCheckedStatus = _ref8.valuesCheckedStatus;
        return {
          valuesCheckedStatus: _objectSpread({}, prevValuesCheckedStatus, _defineProperty({}, checkboxValue, checkboxIsChecked))
        };
      }, function () {
        if (_this2.props.onChange) {
          // Need to convert from lookup to list of checked values
          var checkedList = _getCheckedList(_this2.state.valuesCheckedStatus);

          _this2.props.onChange(checkedList, {
            isChecked: checkboxIsChecked,
            value: checkboxValue
          });
        }
      });
    }
  }, {
    key: "_handleCheckboxBlur",
    value: function _handleCheckboxBlur() {
      if (this.props.onBlur) {
        // Need to convert from lookup to list of checked values
        var checkedList = _getCheckedList(this.state.valuesCheckedStatus);

        this.props.onBlur(checkedList);
      }
    }
  }, {
    key: "_handleCheckboxFocus",
    value: function _handleCheckboxFocus() {
      if (this.props.onFocus) {
        // Need to convert from lookup to list of checked values
        var checkedList = _getCheckedList(this.state.valuesCheckedStatus);

        this.props.onFocus(checkedList);
      }
    }
  }, {
    key: "_getCheckboxes",
    value: function _getCheckboxes() {
      var _this3 = this;

      var _this$props = this.props,
          name = _this$props.name,
          values = _this$props.values,
          disabledList = _this$props.disabledList,
          numberOfColumns = _this$props.numberOfColumns;
      var valuesCheckedStatus = this.state.valuesCheckedStatus;
      var checkboxComponents = values.map(function (valueInfo, index) {
        var isDisabled = includes(disabledList, valueInfo.value);
        var isChecked = valuesCheckedStatus[valueInfo.value];
        return React.createElement(CheckboxComponent, {
          key: valueInfo.value,
          index: index,
          name: name,
          value: isChecked,
          htmlValue: valueInfo.value,
          display: valueInfo.display,
          isDisabled: isDisabled,
          numberOfColumns: numberOfColumns,
          onChange: _this3._handleCheckboxChange.bind(_this3),
          onBlur: _this3._handleCheckboxBlur.bind(_this3),
          onFocus: _this3._handleCheckboxFocus.bind(_this3)
        });
      });
      return checkboxComponents;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          inline = _this$props2.inline,
          dataSpec = _this$props2['data-spec'],
          __containerClassName = _this$props2.__containerClassName;
      var wrapperClassName = classNames('eds-checkbox-group', {
        'eds-checkbox-group--inline': inline
      }, __containerClassName);
      return React.createElement("div", {
        id: id,
        className: wrapperClassName,
        "data-spec": dataSpec
      }, this._getCheckboxes());
    }
  }]);

  return CheckboxGroup;
}(PureComponent);

_defineProperty(CheckboxGroup, "propTypes", {
  /**
   * Checkbox group name
  */
  name: PropTypes.string.isRequired,

  /**
   * Array of formatted checkbox group like data options
   * (value: The checkbox-group value & display: The checkbox-group displayed label)
   */
  values: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    display: PropTypes.node.isRequired
  })).isRequired,

  /**
   * The checked checkboxes in the checkbox group, overriding any existing state.
   * Named "value" for parity with the other input components.
   *
   * In most cases, `value` should be an array of strings, where each string
   * represents a checked checkbox id. However, we also allow `value` to be
   * specifically the empty string to prevent a console warning when this
   * component is used with redux-form, as redux-form passes an empty string
   * rather than an empty list, the very first time a checkbox group is clicked.
   * See the Phabricator diffs linked in EB-57544 and EB-61970 for more context.
   * We then convert the empty string to an empty list in the relevant helper
   * functions.
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.oneOf([''])]),

  /**
   * The initially checked checkboxes in the checkbox group.
   * It will not override the state after it's been created.
   * Named "defaultValue" for parity with the other input components.
   */
  defaultValue: PropTypes.arrayOf(PropTypes.string),

  /**
   * Display the checkbox group list inline
   */
  inline: PropTypes.bool,

  /**
   * ID of checkbox group component's wrapper
   */
  id: PropTypes.string,

  /**
   * List of values for disabled checkbox group buttons
   */
  disabledList: PropTypes.arrayOf(PropTypes.string),

  /**
   * Number of columns for the checkboxes to be displayed in
   * Test number of columns: 1, 2, 3, 4
   */
  numberOfColumns: PropTypes.oneOf([1, 2, 3, 4]),

  /**
   * Function to be invoked when the set of checked checkboxes changes.
   * Passed an array of checked values and an object with 'isChecked'
   * and 'value'
   */
  onChange: PropTypes.func,

  /**
   * Function To be invoked when a checkbox in the group is blurred.
   * Passed an array of checked values
   */
  onBlur: PropTypes.func,

  /**
   * Function to be invoked when a checkbox in the group is focused.
   * Passed an array of checked values
   */
  onFocus: PropTypes.func,

  /**
   * Class names for checkbox group component wrapper
   */
  __containerClassName: PropTypes.string,
  'data-spec': PropTypes.string
});

_defineProperty(CheckboxGroup, "defaultProps", {
  defaultValue: [],
  inline: false,
  numberOfColumns: 1,
  'data-spec': 'checkbox-group-wrapper'
});

export { CheckboxGroup as default };